<div class="starfsfolk wrapper">
  <div class="starfsfolk__grid">
    <en-employee
      *ngFor="let employee of employees"
      [content]="employee.data"
    ></en-employee>
  </div>
</div>
